import { ProductUpsertModel } from './bulk-add-product.model';

export class ProductUpsertArrayModel {
  upsertArray: ProductUpsertModel[];
}
